// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Sea1M","title":"FrontImage_title__1ZR4-"};